<td-wb-empty>
  <td-wb-icon tdWbEmptyIcon
              class="td-wb-learn-no-result__icon"
              iconId="empty-search"
              size="70x70" />
  <td-wb-empty-header translate="tdWb.learn.noResult.NO_CONTENT_TITLE" />
  <td-wb-empty-sub-header translate="tdWb.learn.noResult.NO_CONTENT_DESCRIPTION" />
</td-wb-empty>

